import styled from '@emotion/styled';

const ButtonList = styled.div({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'space-evenly'
});

export default ButtonList;
